import { render, staticRenderFns } from "./IconSvgSubtract.vue?vue&type=template&id=b577f742&scoped=true&"
import script from "./IconSvgSubtract.vue?vue&type=script&lang=js&"
export * from "./IconSvgSubtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b577f742",
  null
  
)

export default component.exports